.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;

  &[data-columns="2"] {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.cell {
  display: flex;
  min-width: 0;
}

// The whole card is the link, so the card's own `!` display wins over Link's module styles, which
// are set outside Tailwind's utility layer.
.item {
  display: flex !important;
  width: 100%;
  min-width: 0;
  flex-direction: column;
  align-items: stretch !important;
  gap: 0.5rem;
  padding: 1.25rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-card);
  color: inherit;
  text-decoration: none;
  transition: border-color 150ms ease;

  &:hover,
  &:focus-visible {
    border-color: var(--color-primary-border);

    .arrow {
      color: var(--color-primary);
      transform: translate(2px, -2px);
    }
  }
}

.top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 0.5rem;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
}

.arrow {
  flex-shrink: 0;
  color: var(--color-muted-foreground);
  transition:
    color 150ms ease,
    transform 150ms ease;
}

.title {
  margin: 0;
}

.body {
  margin: 0;
  text-wrap: balance;
}

@media (prefers-reduced-motion: reduce) {
  .arrow {
    transition: none;
  }
}

@media (max-width: 1000px) {
  .grid,
  .grid[data-columns="2"] {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .grid,
  .grid[data-columns="2"] {
    grid-template-columns: minmax(0, 1fr);
  }
}
